/**
 * @name massageTokens
 * @description It produces new tokens object with replaced values
 */
const massageTokens = theme => {
	/**
	 * @description Helper function that replaces e.g. `"color1": "primary"` to `"color1": "#ffffff"` based on varsList
	 */
	const replaceVars = (nameToReplace = "", varsList = []) => {
		const found = varsList.find(item => item.id === nameToReplace)
		if (!found) return nameToReplace
		return found.value
	}

	const output = {}

	Object.keys(theme.tokens).forEach(key => {
		// Colors
		if (theme.colors && key.includes("color")) output[key] = replaceVars(theme.tokens[key], theme.colors)
		// Font faces
		else if (theme.typeFaces && key.includes("fontFamily")) output[key] = replaceVars(theme.tokens[key], theme.typeFaces)
		// Shadows
		else if (theme.shadows && key.includes("shadow")) output[key] = replaceVars(theme.tokens[key], theme.shadows)
		// Transition durations
		else if (theme.transitions && key.includes("transition")) output[key] = replaceVars(theme.tokens[key], theme.transitions)
		// Others
		else output[key] = theme.tokens[key]
	})

	return output
}

/**
 * @name buildTheme
 * @description Build theme for tenant. It receives theme object from tenant config and creates css string with
 * css variables definitions.
 */
const buildTheme = theme => {
	let output = ``

	/**
	 * Add typefaces
	 */
	theme.typeFaces.forEach(item => {
		if (item.url) output += `@import url("${item.url}"); \n`
	})

	/**
	 * Construct theme in css as string
	 */
	output += `@supports(--css: variables) { \n`
	output += `:root{ \n`

	// Go through all tokens and create lines:
	Object.keys(theme.tokens).forEach(key => {
		output += `--${key}: ${theme.tokens[key]}; \n`
	})

	output += `}\n`
	output += `}`

	// Appnd customCss if there is any
	if (theme?.customCss?.cssString) output += ` ${theme.customCss.cssString} `

	return output
}

/**
 * @name testCssVariables
 * @description Will properly test if a browser supports css variables
 * This version is working on Safari as well
 */
const testCssVariables = () => {
	const color = "rgb(255, 198, 0)"
	const el = document.createElement("span")

	el.style.setProperty("--color", color)
	el.style.setProperty("background", "var(--color)")
	document.body.appendChild(el)

	const styles = getComputedStyle(el)
	const doesSupport = styles.backgroundColor === color
	document.body.removeChild(el)
	return doesSupport
}

export { buildTheme, massageTokens, testCssVariables }
